let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("deyvi"), load("4UPfH"), load("cdeuH"), load("aNg21"), load("2Fu3d")]).then(() => parcelRequire('9BoM3'));